import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInfo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 10,
	height: 10,
	viewBox: "0 0 10 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 5,
		cy: 5,
		r: 4.75,
		stroke: "currentColor",
		strokeWidth: .5
	}), /* @__PURE__ */ _jsx("path", {
		d: "M4.45865 4.92392C4.45865 4.4917 4.80903 4.14131 5.24126 4.14131V6.48914C5.24126 6.92136 4.89087 7.27175 4.45865 7.27175V4.92392ZM4.34778 3.07827C4.34778 2.95218 4.39343 2.84349 4.48473 2.75218C4.58039 2.65653 4.69995 2.6087 4.84343 2.6087C4.98691 2.6087 5.10647 2.65436 5.20213 2.74566C5.30213 2.83262 5.35213 2.94349 5.35213 3.07827C5.35213 3.21305 5.30213 3.32609 5.20213 3.4174C5.10647 3.50436 4.98691 3.54783 4.84343 3.54783C4.69995 3.54783 4.58039 3.50218 4.48473 3.41088C4.39343 3.31523 4.34778 3.20436 4.34778 3.07827Z",
		fill: "currentColor"
	})]
});
export default SvgInfo;
